import { z } from "zod";

/**
 * Phase 6 — Angebots-Manifest. Die echten Files (xlsx/pdf/gaeb) liegen
 * neben dieser JSON im Run-Verzeichnis. Hier nur Metadaten + Pfade.
 */
export const AngebotsArtefaktSchema = z.object({
  format: z.enum(["xlsx", "pdf", "gaeb"]),
  relPath: z.string(),
  groesseBytes: z.number().int().nonnegative(),
  erzeugtAm: z.string().datetime(),
});
export type AngebotsArtefakt = z.infer<typeof AngebotsArtefaktSchema>;

export const AngebotSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  artefakte: z.array(AngebotsArtefaktSchema).default([]),
  anschreibenText: z.string().default(""),
  positionenAnzahl: z.number().int().nonnegative().default(0),
  summeNetto: z.number().default(0),
  // Markiert, dass Phase-4/5-Aenderungen seit der letzten Generierung
  // passiert sind. Artefakte sind dann "stale" — User sollte Pipeline
  // ab Phase 6 neu rennen, bevor das Angebot rausgeht.
  veraltet: z.boolean().default(false),
  // Zeitpunkt, an dem das Manifest als veraltet markiert wurde. Null
  // solange veraltet=false.
  staleSeit: z.string().datetime().nullable().default(null),
});

export type Angebot = z.infer<typeof AngebotSchema>;
